/**
 * Enterprise tier.
 *
 * Enterprise is a direct company contract — it is not sold or billed through
 * Stripe or the mobile stores, and neither the app nor the backend handles any
 * payment for it (its `subscription.provider` is `"aydi"`). So every
 * payment-related surface is hidden for these accounts: pricing pages,
 * checkout, the Stripe billing portal, Plan & Usage, upgrade/upsell CTAs and
 * the payment-failure banner.
 *
 * Feature-wise it behaves like a Teams plan — `isTeamsSubscription` (see
 * `shared/api.ts`) is true for Enterprise, so the whole Teams flow (My Team,
 * roles, invitations, public chats, action assignees) is available. All chat
 * models are included, and when an account does run out of AI credit or storage
 * it gets the "Book a call" variant instead of an upgrade CTA.
 *
 * This module deliberately has no imports so it can be used from the edge
 * middleware as well as the client.
 */
export const ENTERPRISE_PLAN_NAME = 'enterprise';

export const isEnterprisePlan = (planName?: string | null): boolean =>
  planName?.toLowerCase() === ENTERPRISE_PLAN_NAME;
